import React from 'react';
import { motion } from 'framer-motion';
import { ArrowIcon } from './icons/ArrowIcon';
export function Hero() {
  const scrollToPrice = () => {
    const element = document.getElementById('precio');
    if (element) {
      const headerOffset = 60;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="relative w-full bg-[#FDFBF7] pt-16 md:pt-32 pb-12 md:pb-20 px-3 md:px-4 overflow-hidden" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        <div className="grid lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center" data-id="element-110">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-4 md:space-y-6 text-center lg:text-left" data-id="element-111">
            <span className="inline-block text-[#D4AF7A] font-medium tracking-[0.2em] text-[9px] md:text-[10px] uppercase" data-id="element-112">
              MASTER HYDRA GLOSS LIPS™ 2.0
            </span>

            <h1 className="text-xl md:text-4xl lg:text-5xl font-semibold text-[#3D3028] leading-[1.15] md:leading-[1.2] tracking-tight" data-id="element-113">
              Convertite en Especialista en Hydra Lips + BB Lips en menos de 7
              días,{' '}
              <span className="text-[#E5A5A0]" data-id="element-114">
                incluso si hoy estás empezando desde cero
              </span>
            </h1>

            <div className="space-y-3 md:space-y-4" data-id="element-115">
              <h2 className="text-sm md:text-base lg:text-lg text-[#3D3028]/70 font-normal leading-snug" data-id="element-116">
                ¿Querés ofrecer un servicio premium, cobrar mejor y destacarte
                como profesional… pero todavía no te sentís segura con la
                técnica?
              </h2>

              <p className="text-xs md:text-sm lg:text-base text-[#3D3028]/60 leading-relaxed" data-id="element-117">
                Este Master fue creado para que dejes de improvisar y empieces a
                trabajar con confianza, método y resultados reales, incluso si
                nunca hiciste Hydra Lips o BB Lips.
              </p>
            </div>

            {/* Hero Image - Mobile Only (between subheadline and CTA) */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="lg:hidden pt-2" data-id="element-118">
              <a href="https://www.hydraglosslips.com/cart/47717496684792:1" className="block relative rounded-xl md:rounded-2xl overflow-hidden shadow-lg md:shadow-xl border border-[#D4C4B0]/20 hover:shadow-2xl transition-shadow duration-300 cursor-pointer" data-id="element-119">
                <img src="https://cdn.magicpatterns.com/uploads/gxRw1MdWcqZdLtypMYVJr9/BB_GLOW_3.png" alt="Procedimiento profesional de Hydra Gloss Lips" className="w-full h-auto object-cover" data-id="element-120" />
              </a>
            </motion.div>

            <div className="pt-3 md:pt-6" data-id="element-121">
              <motion.button onClick={scrollToPrice} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center gap-2 bg-[#E5A5A0] text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium shadow-sm hover:bg-[#d99590] transition-colors duration-300" data-id="element-122">
                Accedé ahora al Master
                <ArrowIcon className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-123" />
              </motion.button>
            </div>
          </motion.div>

          {/* Hero Image - Desktop Only (side by side) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="hidden lg:block relative" data-id="element-124">
            <a href="https://www.hydraglosslips.com/cart/47717496684792:1" className="block relative rounded-2xl overflow-hidden shadow-xl border border-[#D4C4B0]/20 hover:shadow-2xl transition-shadow duration-300 cursor-pointer" data-id="element-125">
              <img src="https://cdn.magicpatterns.com/uploads/gxRw1MdWcqZdLtypMYVJr9/BB_GLOW_3.png" alt="Procedimiento profesional de Hydra Gloss Lips" className="w-full h-auto object-cover" data-id="element-126" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}